<template>
  <div>
    <img class="title" :src="info.topImgUrl" alt="" />
    <div class="imgpath flex-js-ac flex-w">
      <div class="pos-r w-50" v-for="(item, index) of info.goodsList" :key="index">
        <img
          class="of-c w-100"
          :src="item.imgUrl"
          alt=""
          @click="clickHandle(item, index)"
        />
        <div
          :path="item.adTarget + (item.adTarget.indexOf('?') >= 0 ? '&' : '?') + 'sorce=15'"
          :username="'gh_5d4bb8e18b8b'"
          class="slide_cl_xcx"
          v-if="isWx && (item.adType == 7 || item.adType == 8)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWeixin } from '../../../assets/common/js/config'
export default {
  name: 'actGoodsAd',
  props: {
    info: {
      type: Object,
      default: {}
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'ITEMSHF'
    },
  },
  data() {
    return {
      isWx: isWeixin() ? 1 : 0
    }
  },
  mounted() {},
  methods: {
    clickHandle(item, index) {
      let info = {
        ad_type: item.adType,
        ad_target: item.adTarget,
        ad_title: item.adtitle,
        ...item
      }
      this.$emit('banner-click', info, index, this.flow_area_prefix)
    },
  }
}
</script>

<style scoped lang="scss">
.title {
  width: 100%;
}
.imgpath img {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/actGoodsAd.vue